// Language definitions with RTL support for 20 languages

export const RTL_LANGUAGES = ['ar', 'he'] as const;

export const languages = {
  en: { name: 'English', nativeName: 'English', dir: 'ltr' as const },
  zh: { name: 'Chinese', nativeName: '中文', dir: 'ltr' as const },
  hi: { name: 'Hindi', nativeName: 'हिन्दी', dir: 'ltr' as const },
  es: { name: 'Spanish', nativeName: 'Español', dir: 'ltr' as const },
  fr: { name: 'French', nativeName: 'Français', dir: 'ltr' as const },
  ar: { name: 'Arabic', nativeName: 'العربية', dir: 'rtl' as const },
  bn: { name: 'Bengali', nativeName: 'বাংলা', dir: 'ltr' as const },
  pt: { name: 'Portuguese', nativeName: 'Português', dir: 'ltr' as const },
  ru: { name: 'Russian', nativeName: 'Русский', dir: 'ltr' as const },
  ja: { name: 'Japanese', nativeName: '日本語', dir: 'ltr' as const },
  de: { name: 'German', nativeName: 'Deutsch', dir: 'ltr' as const },
  ko: { name: 'Korean', nativeName: '한국어', dir: 'ltr' as const },
  vi: { name: 'Vietnamese', nativeName: 'Tiếng Việt', dir: 'ltr' as const },
  tr: { name: 'Turkish', nativeName: 'Türkçe', dir: 'ltr' as const },
  it: { name: 'Italian', nativeName: 'Italiano', dir: 'ltr' as const },
  th: { name: 'Thai', nativeName: 'ไทย', dir: 'ltr' as const },
  pl: { name: 'Polish', nativeName: 'Polski', dir: 'ltr' as const },
  nl: { name: 'Dutch', nativeName: 'Nederlands', dir: 'ltr' as const },
  id: { name: 'Indonesian', nativeName: 'Bahasa Indonesia', dir: 'ltr' as const },
  he: { name: 'Hebrew', nativeName: 'עברית', dir: 'rtl' as const },
} as const;

export type LanguageCode = keyof typeof languages;
export type LanguageDirection = 'ltr' | 'rtl';

export interface LanguageInfo {
  name: string;
  nativeName: string;
  dir: LanguageDirection;
}

export const languageCodes = Object.keys(languages) as LanguageCode[];

export function isRTLLanguage(lang: string): boolean {
  return RTL_LANGUAGES.includes(lang as typeof RTL_LANGUAGES[number]);
}

export function getLanguageInfo(lang: string): LanguageInfo {
  return languages[lang as LanguageCode] || languages.en;
}

export function getLanguageDirection(lang: string): LanguageDirection {
  return getLanguageInfo(lang).dir;
}
